import { ConsentSigningSection } from "@/features/consent/components/ConsentSigningSection";
import { createFileRoute } from "@tanstack/react-router";

function DiaryConsentSetupPage() {
    const { consentId, diaryId } = Route.useParams();

    return <ConsentSigningSection consentId={consentId} diaryId={diaryId} routeContext="diaries" />;
}

export const Route = createFileRoute("/_app/diaries/$diaryId/setup/consent/$consentId/")({
    component: DiaryConsentSetupPage,
});
